import { render, staticRenderFns } from "./ScreensaversList.vue?vue&type=template&id=1500e986&scoped=true&"
import script from "./ScreensaversList.vue?vue&type=script&lang=ts&"
export * from "./ScreensaversList.vue?vue&type=script&lang=ts&"
import style0 from "./ScreensaversList.vue?vue&type=style&index=0&id=1500e986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500e986",
  null
  
)

export default component.exports